import StepLabel from '@zenbusiness/zui/StepLabel';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { StepperContainer, StepContainer } from './Stepper.styles';

const CustomStepper = ({ steps = [] }) => (
  <StepperContainer
    activeStep={-1}
    orientation="vertical"
  >
    {steps &&
      steps.map(({ description, title }) => (
        <StepContainer key={title}>
          <StepLabel
            optional={
              <Text
                aria-label="step description"
                color="secondary"
                size="md"
                weight="medium"
              >
                {description}
              </Text>
            }
            variant="active"
          >
            <Text
              aria-label="step title"
              color="primary"
              size="xl"
              weight="medium"
            >
              {title}
            </Text>
          </StepLabel>
        </StepContainer>
      ))}
  </StepperContainer>
);

CustomStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string
    })
  )
};

export default CustomStepper;
